import { laravelGet, laravelPost } from '../utils/laravelClient';

export const recordMenuClick = (type, targetId) => {
  const id = Number(targetId);
  if (!Number.isInteger(id) || id <= 0) {
    return Promise.resolve(null);
  }

  return laravelPost('/menu-clicks', { type, target_id: id }, { auth: 'none' }).catch(() => null);
};

export const fetchMenuClicks = (days = 30) =>
  laravelGet('/menu-clicks', { auth: 'admin', params: { days } });
